import type { RouteRecordRaw } from "vue-router";

export const salesWizardRoutes: RouteRecordRaw[] = [
  {
    path: "/kontaktformular/new",
    name: "sales-wizard-entry",
    component: () => import("./entry/SalesWizardEntryPage.vue"),
    meta: {
      namespace: "sales_wizard",
    },
  },
  {
    path: "/kontaktformular/:publicId",
    name: "sales-wizard-confirmation",
    component: () => import("./confirmation/SalesWizardConfirmationPage.vue"),
    meta: {
      namespace: "sales_wizard",
    },
  },
  {
    // Step routes live under the wizard shell (step indicator + layout);
    // entry and confirmation intentionally stay outside of it.
    path: "/kontaktformular/:publicId",
    component: () => import("./SalesWizardLayout.vue"),
    meta: {
      namespace: "sales_wizard",
    },
    children: [
      {
        path: "kontaktdaten/new",
        name: "sales-wizard-contact",
        component: () => import("./steps/SalesWizardContactStepPage.vue"),
        meta: {
          namespace: "sales_wizard",
          wizardStep: "contact",
        },
      },
      {
        path: "schule/new",
        name: "sales-wizard-school",
        component: () => import("./steps/SalesWizardSchoolStepPage.vue"),
        meta: {
          namespace: "sales_wizard",
          wizardStep: "school",
        },
      },
      {
        path: "auswahl/new",
        name: "sales-wizard-choice",
        component: () => import("./steps/SalesWizardChoiceStepPage.vue"),
        meta: {
          namespace: "sales_wizard",
          wizardStep: "license",
        },
      },
      {
        path: "zusatz-auswahl/new",
        name: "sales-wizard-workshops",
        component: () => import("./steps/SalesWizardWorkshopStepPage.vue"),
        meta: {
          namespace: "sales_wizard",
          wizardStep: "workshops",
        },
      },
    ],
  },
];
